module.exports = "/images/vendor/flag-icon-css/flags/1x1/bq.svg?d6da2e848d831d87d51683d9340dbd38";